export const templateDataFormCode = {
  ReservationContract: 'ReservationContract',
  InternalManagementDoc: 'DOC_INTERNO_GEST',
  ResponsibleDeclaration: 'DECLARACION_RESPONSABLE'
}
